import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import {
  AppBar,
  Autocomplete,
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  Dialog,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography,
} from '@mui/material';
import Select from '@mui/material/Select';
import { Radio } from 'antd';
import { useSnackbar } from 'notistack';
import React, { memo, useContext, useEffect, useState } from 'react';
import { connectOtherDatabase, getSecretsList } from "../../../../api's/ConnectorsApi";
import {
  fetchPostgresColumn,
  fetchPostgresColumn2,
  fetchPostgresSchema,
  fetchPostgresSchema2,
  fetchPostgresTables,
  fetchPostgresTables2,
} from "../../../../api's/DataProcessorApi";
import { AWS_CONFIG_TYPE } from '../../../../BaseUrl';
import { AuthContext } from '../../../../context/AuthProvider';
import InputField from '../../../../reusable-component/InputField';
import LoadingIcon from '../../../../reusable-component/LoadingIcon';
import { populateNodeData } from '../../copilot/utils/CopilotUtils';
import { WorkflowContext } from '../../../../contexts/WorkflowProvider';
import useDebounce from '../../../../hooks/useDebounce';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const INITIALSTATE = {
  path: '',
  format: 'postgres',
  connection_type: '',
  secret_name: '',
  secretsList: [],
  action: '',
  persist: false,
  alias: '',
  persist_type: '',
  database: '',
  delimiter: ',',
  tablename: '',
  schema: '',
  ignoreblanklines: false,
  skipheaders: false,
  columnshift: false,
  junkrecords: false,
  linebreak: false,
  distinct_rows: false,
  clientId: '',
  clientName: '',
  batchName: '',
  tableNameRead: '',
  trackingId: '',
  innerPath: '',
  file: '',
  dataTypeRead: 'source',
  pagination: false,
  lowerBound: '',
  upperBound: '',
  CDC: false,
  partitionColumn: '',
  numPartitions: '',
  sample_view: true,
  priority: '',
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: '#fff',
  border: '1px solid #000',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
};

const NodeModalReadPostgres2 = ({
  open,
  handleClose,
  nodeId,
  nodeName,
  nodes,
  edges,
  changeNodeName,
  setNodes,
  dataModel = false,
  dataModelformField,
  setDataModelformField = () => { },
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { userRole, userGroup } = useContext(AuthContext);
  const { workflow } = useContext(WorkflowContext);

  const src = dataModelformField?.source ?? {};
  const InitialData = dataModel
    ? {
      formField: src.formField ?? INITIALSTATE,
      headerName: src.headerName?.length ? src.headerName : [],
      fetchedHeader: src.fetchedHeader?.length ? src.fetchedHeader : [],
      postgresTables: src.postgresTables?.length ? src.postgresTables : [],
      connectionType: src.connectionType ?? '',
      secretsList: src.secretsList?.length ? src.secretsList : [],
      postgresSchemas: src.postgresSchemas?.length ? src.postgresSchemas : ['public'],
    }
    : {
      formField: INITIALSTATE,
      headerName: [],
      fetchedHeader: [],
      postgresTables: [],
      connectionType: '',
      secretsList: [],
      postgresSchemas: ['public'],
    };

  const [formField, setFormField] = useState(InitialData.formField);
  const [disableForm, setDisableForm] = useState(false);
  const [headerName, setHeaderName] = useState(InitialData.headerName);
  const [fetchedHeader, setFetchedHeader] = useState(InitialData.fetchedHeader);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [isDataLoad, setisDataLoad] = useState(false);
  const [addColumn, setAddColumn] = useState('');
  const [defaultValue, setDefaultValue] = useState('');
  const [tempHeader, setTempHeader] = useState([]);
  const [attributeType, setAttributeType] = useState('static');
  const [postgresDatabases, setPostgresDatabases] = useState([]);
  const [postgresSchemas, setPostgresSchemas] = useState(InitialData.postgresSchemas);

  const [postgresTables, setPostgresTables] = useState(InitialData.postgresTables);

  const [connectionType, setConnectionType] = useState(InitialData.connectionType);
  const [secretsList, setSecretsList] = useState(InitialData.secretsList);
  const [selectedSecret, setSelectedSecret] = useState('');

  const attributeOptions = [
    {
      label: 'Static',
      value: 'static',
    },
    {
      label: 'Function',
      value: 'function',
    },
  ];

  const [addColumnModalOpen, setAddColumnModalOpen] = useState(false);
  const handleAddColumnModalOpen = () => setAddColumnModalOpen(true);
  const handleAddColumnModalClose = () => setAddColumnModalOpen(false);

  const debouncedFormField = useDebounce(formField, 200);

  useEffect(() => {
    if (!dataModel) return;

    const newSource = {
      nodeId,
      nodeName,
      formField: debouncedFormField,
      headerName,
      fetchedHeader,
      postgresTables,
      postgresSchemas,
      connectionType,
      secretsList,
      step_name: nodeName,
    };
    const prevSource = dataModelformField?.source;

    if (
      JSON.stringify(prevSource?.formField) === JSON.stringify(newSource.formField) &&
      JSON.stringify(prevSource?.headerName) === JSON.stringify(newSource.headerName) &&
      JSON.stringify(prevSource?.fetchedHeader) === JSON.stringify(newSource.fetchedHeader) &&
      JSON.stringify(prevSource?.postgresTables) === JSON.stringify(newSource.postgresTables) &&
      JSON.stringify(prevSource?.connectionType) === JSON.stringify(newSource.connectionType) &&
      JSON.stringify(prevSource?.secretsList) === JSON.stringify(newSource.secretsList) &&
      JSON.stringify(prevSource?.postgresSchemas) === JSON.stringify(newSource.postgresSchemas)
    ) {
      return;
    }

    setDataModelformField((prev) => ({
      ...prev,
      source: newSource,
    }));
  }, [
    debouncedFormField,
    headerName,
    fetchedHeader,
    postgresTables,
    connectionType,
    secretsList,
    postgresSchemas,
    dataModel,
  ]);

  const checklabel = { inputProps: { 'aria-label': 'Checkbox demo' } };

  const handleHeaderChange = (obj) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === obj.header;
    });

    if (selectedIndex === -1 && obj.checked) {
      setHeaderName([...headerName, obj]);

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              header: obj.header,
              alias: obj.alias,
              checked: true,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && obj.checked) {
      setHeaderName((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && !obj.checked) {
      setHeaderName((current) =>
        current.filter((object) => {
          return object.header !== obj.header;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              checked: false,
              alias: '',
              cast_datatype: 'string',
              attribute_type: 'static',
              default_value: '',
            };
          }

          return object;
        })
      );
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = fetchedHeader.map((n) => {
        const all = {
          header: n.header,
          alias: n.alias,
          checked: true,
          cast_datatype: 'string',
          attribute_type: 'static',
          default_value: '',
        };
        return all;
      });
      setHeaderName(newSelecteds);
      return;
    }
    setHeaderName([]);
  };

  const isSelected = (name) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === name;
    });

    return selectedIndex !== -1;
  };

  const handleAddColumn = () => {
    setFetchedHeader([
      ...fetchedHeader,
      {
        header: addColumn,
        alias: '',
        checked: false,
        cast_datatype: 'string',
        default_value: defaultValue,
        attribute_type: attributeType,
      },
    ]);
    handleAddColumnModalClose();
    setAddColumn('');
    setDefaultValue('');
  };

  const schemaSelected = (newSchema) => {
    setFormField({
      ...formField,
      schema: newSchema,
      tablename: '',
    });
    setFetchedHeader([]);
    getPostgresTables(newSchema, formField.connection_type, formField.secret_name);
  };

  const store = JSON.parse(sessionStorage.getItem('allNodes'));

  const getLocalData = () => {
    if (store) {
      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField);
          setisDataLoad(true);
          setHeaderName(node.headerName);
          setTempHeader(node.headerName);
          setConnectionType(node.formField.connection_type);
          setFetchedHeader(node.fetchedHeader);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
          if (node.formField.connection_type === 'other' && node.formField.secret_name) {
            fetchSecrets();
          }
          getPostgresSchema(node.formField.secret_name, node.formField.database, node.formField.connection_type);
          getPostgresTables(node.formField.schema, node.formField.connection_type, node.formField.secret_name);
        }
      });
    }
  };

  useEffect(() => {
    setFormField(InitialData.formField);
    setDisableForm(false);
    setFetchedHeader(InitialData.fetchedHeader);
    setHeaderName(InitialData.headerName);
    getLocalData();
  }, [nodeId]);

  let name, value;
  const handleInputChange = (e) => {
    name = e.target.name;
    if (
      name === 'ignoreblanklines' ||
      name === 'linebreak' ||
      name === 'skipheaders' ||
      name === 'columnshift' ||
      name === 'junkrecords' ||
      name === 'pagination'
    ) {
      value = e.target.checked;
    } else {
      value = e.target.value;
    }

    setFormField({
      ...formField,
      [name]: value,
    });
  };

  const handleResetForm = () => {
    setFormField(INITIALSTATE);
  };

  const compareTwoArrayOfObjects = (first_array_of_objects, second_array_of_objects) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    if (!formField.alias.trim()) {
      enqueueSnackbar('Alias is required!', { variant: 'error' });
      return;
    }

    const newHeaderName = [];

    headerName.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (count <= connectedNodes.length && node.id === connectedNodes[count]) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem('updatedNodes', JSON.stringify(connectedNodes));

    setHeaderName(newHeaderName);

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem('allNodes', JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        el.data.label = formField.alias;
      }
    });

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField,
      disabled: true,
      step_name: nodeName,
      headerName: newHeaderName,
      fetchedHeader,
      // flowbuilderRowLevelOperation
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem('node', JSON.stringify(nodes));
    sessionStorage.setItem('edges', JSON.stringify(edges));

    const fetchNodesData = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem('allNodes', JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node') || '[]');
    getElements.push(nodeId);
    sessionStorage.setItem('saved_node', JSON.stringify(getElements));
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });

    // setTempHeader(headerName);

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el['disabled'] = false;
      }
    });

    sessionStorage.setItem('allNodes', JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node'));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem('saved_node', JSON.stringify(newSavedElement));
  };

  const getPostgresTables = async (schema, connectionType, secret_name) => {
    setLoadingBtn(true);
    try {
      const response = await fetchPostgresTables2(schema, AWS_CONFIG_TYPE, connectionType, secret_name);

      if (response.status === 200) {
        const tables = [];
        response.data.forEach((el) => {
          tables.push(el.label);
        });
        setPostgresTables(tables);
      }
    } catch (error) {
      setPostgresTables([]);
      setFormField({
        ...formField,
        tablename: '',
        schema: '',
      });
      setFetchedHeader([]);
      enqueueSnackbar('Tables not found!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
    setLoadingBtn(false);
  };

  const getPostgresColumn = async (table) => {
    setLoadingBtn(true);

    try {
      let response;
      if (connectionType === 'default') {
        response = await fetchPostgresColumn(formField.database, formField.schema, table, AWS_CONFIG_TYPE);
      } else {
        response = await fetchPostgresColumn2(
          formField.schema,
          table,
          AWS_CONFIG_TYPE,
          formField.secret_name,
          connectionType
        );
      }
      if (response.status === 200) {
        const header = [];

        response.data.forEach((el) => {
          header.push({
            header: el,
            alias: '',
            checked: false,
            tableAlias: '',
            cast_datatype: 'string',
            default_value: '',
            attribute_type: 'static',
          });
        });

        setFetchedHeader(header);
      }
    } catch (error) {
      enqueueSnackbar('Columns not found!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }

    setLoadingBtn(false);
  };

  const getPostgresSchema = async (secret, database, connection_type) => {
    try {
      const payload = {
        connectionType: connection_type,
        secret_name: secret,
      };
      const response = await fetchPostgresSchema2(database, AWS_CONFIG_TYPE, payload);
      if (response.status === 200) {
        const tables = [];
        response.data.forEach((el) => {
          tables.push(el.label);
        });
        setPostgresSchemas(tables);
      }
    } catch (error) {
      enqueueSnackbar('Schema not found!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  const handleChecked = (event) => {
    setFormField({ ...formField, sample_view: event.target.checked });
  };

  const fetchSecrets = async () => {
    setLoadingBtn(true);
    try {
      const response = await getSecretsList('postgresql'); // Adjust if needed
      setSecretsList(response.data);
    } catch (error) {
      enqueueSnackbar('Secrets not found!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
    setLoadingBtn(false);
  };

  const handleConnectionChange = async (event) => {
    const connectionType = event.target.value; // Corrected variable name
    setFormField((prevFormField) => ({
      ...prevFormField,
      tablename: '',
      connection_type: connectionType,
      secret_name: '',
      schema: '',
    }));

    setFetchedHeader([]);
    setPostgresTables([]);
    setConnectionType(connectionType);
    setSelectedSecret('');

    if (connectionType === 'other') {
      fetchSecrets();
    }
    if (connectionType === 'default') {
      try {
        const response = await connectOtherDatabase('default', 'postgresql', connectionType);
        if (response.status === 200) {
          setFormField((prevFormField) => ({
            ...prevFormField,
            tablename: '',
            connection_type: connectionType,
            secret_name: '',
            schema: '',
            database: response.data.database,
          }));
          enqueueSnackbar('Database connected!', {
            variant: 'success',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }
        getPostgresSchema('null', formField.database, connectionType);
      } catch (error) {
        enqueueSnackbar('Something went wrong!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    }
  };

  const handleSecretSelection = async (secret) => {
    setLoadingBtn(true);

    setFormField({
      ...formField,
      tablename: '',
      secret_name: secret, // Store selected secret
      schema: '',
    });
    setFetchedHeader([]);
    setPostgresTables([]);
    setSelectedSecret(secret);

    try {
      const response = await connectOtherDatabase(secret, 'postgresql', formField.connection_type);
      if (response.status === 200) {
        enqueueSnackbar('Database connected!', {
          variant: 'success',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
        if (formField.connection_type === 'other') {
          setFormField({
            ...formField,
            secret_name: secret,
            database: response.data.database,
            tablename: '',
            schema: '',
          });
          const response2 = await getPostgresSchema(secret, response.data.database, formField.connection_type);
        }
      }
    } catch (error) {
      setPostgresTables([]);
      setPostgresSchemas([]);
      enqueueSnackbar(`Connection Failed..`, {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      enqueueSnackbar(`Please update ${secret} secret!!`, {
        variant: 'error',
        autoHideDuration: 5000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
    setLoadingBtn(false);
  };

  useEffect(() => {
    populateNodeData({
      workflow,
      nodeId,
      setFetchedHeader,
      setHeaderName,
      setFormField,
    });
  }, [workflow.copilotAddedPipeline, workflow.copilotOpen, nodeId]);

  const content = (
    <>
      <div style={{ margin: '20px' }}>
        <input type="hidden" value={nodeId} />

        <Box
          component="form"
          sx={{
            '& > :not(style)': { m: 2, width: '30ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <InputField
            name="alias"
            label="Alias"
            value={formField.alias}
            onChange={handleInputChange}
            size="small"
            disabled={disableForm}
            required
          />
          <FormControlLabel
            control={
              <Checkbox size="small" checked={formField.sample_view} onChange={handleChecked} disabled={disableForm} />
            }
            label="Sample View"
            sx={{ pl: 1 }}
          />
        </Box>

        <Box
          component="form"
          sx={{
            '& > :not(style)': { m: 2, width: '30ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-basic"
            // select
            label="Format"
            variant="outlined"
            value="postgres"
            // onChange={handleInputChange}
            name="format"
            size="small"
            disabled
            required
            InputProps={{
              style: {
                fontFamily: "'EB Garamond', serif ",
                fontWeight: 600,
              },
            }}
            InputLabelProps={{ style: { fontFamily: "'EB Garamond', serif " } }}
          />

          <FormControl size="small">
            <InputLabel id="demo-select-small-label">Connection Type</InputLabel>
            <Select
              labelId="connection-type-label"
              id="connection-type-select"
              value={formField.connection_type}
              label="Connection Type"
              disabled={disableForm}
              required
              onChange={handleConnectionChange}
            >
              <MenuItem value="default">Default</MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </Select>
          </FormControl>
          {formField.connection_type === 'other' && (
            <FormControl size="small">
              <InputLabel id="secrets-list-label">Select Connection</InputLabel>
              <Select
                labelId="secrets-list-label"
                id="secrets-list-select"
                value={formField.secret_name}
                label="Select connection"
                required
                disabled={disableForm}
                onChange={(e) => handleSecretSelection(e.target.value)}
              >
                {secretsList?.length > 0 ? (
                  secretsList?.map((secret, index) => (
                    <MenuItem key={secret} value={secret}>
                      {secret}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No Connection available</MenuItem>
                )}
              </Select>
            </FormControl>
          )}
          <InputField id="flowbuilder-database" value={formField.database} disabled size="small" label="Database" />
        </Box>

        {formField.format === 'postgres' && (
          <Box
            component="form"
            sx={{
              '& > :not(style)': { m: 2, width: '30ch' },
            }}
            noValidate
            autoComplete="off"
          >
            <FormControl size="small">
              <InputLabel id="flowbuilder-schema-label">Schema</InputLabel>
              <Select
                labelId="flowbuilder-schema-list-label"
                id="flowbuilder-schema-select"
                value={formField.schema}
                label="Schema"
                required
                disabled={disableForm}
                onChange={(e) => schemaSelected(e.target.value)}
              >
                {postgresSchemas.length > 0 ? (
                  postgresSchemas.map((schema, index) => (
                    <MenuItem key={schema} value={schema}>
                      {schema}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No schema available</MenuItem>
                )}
              </Select>
            </FormControl>

            <Autocomplete
              disablePortal
              id="flowbuilder-oracle"
              value={formField.tablename || null}
              disabled={disableForm}
              onChange={(event, newValue) => {
                setFormField({
                  ...formField,
                  tablename: newValue,
                });
                getPostgresColumn(newValue);
              }}
              options={postgresTables}
              // getOptionLabel={(option) => (option.label ? option.label : '')}
              size="small"
              sx={{ width: '40%' }}
              renderInput={(params) => <TextField {...params} label="Tables " required />}
            />
          </Box>
        )}

        {loadingBtn && (
          <Box>
            <LoadingIcon />
          </Box>
        )}

        {!loadingBtn && fetchedHeader.length > 0 && (
          <TableContainer sx={{ maxHeight: 300 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Checkbox
                      color="primary"
                      checked={fetchedHeader.length === headerName.length}
                      onChange={handleSelectAllClick}
                      disabled={disableForm}
                    />
                    Select Columns
                  </TableCell>
                  <TableCell>Columns</TableCell>
                  <TableCell>Datatype</TableCell>
                  <TableCell>Alias</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fetchedHeader.map((row, i) => {
                  const isItemSelected = isSelected(row.header);
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={i}
                      selected={isItemSelected}
                    >
                      <TableCell>
                        <Checkbox
                          checked={isItemSelected}
                          disabled={disableForm}
                          onChange={(event) =>
                            handleHeaderChange({
                              header: row.header,
                              alias: '',
                              checked: event.target.checked,
                              cast_datatype: row.cast_datatype ? row.cast_datatype : 'string',
                              default_value: row.default_value,
                              attribute_type: row.attribute_type,
                            })
                          }
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      </TableCell>
                      <TableCell>{row.header}</TableCell>

                      <TableCell>
                        <TextField
                          id="standard-select-currency"
                          select
                          label="Cast Datatype"
                          name="cast_datatype"
                          disabled={disableForm}
                          value={row.cast_datatype ? row.cast_datatype : 'string'}
                          onChange={(event) =>
                            handleHeaderChange({
                              header: row.header,
                              alias: row.alias,
                              checked: true,
                              cast_datatype: event.target.value,
                              default_value: row.default_value,
                              attribute_type: row.attribute_type,
                            })
                          }
                          style={{ width: '100%' }}
                          size="small"
                        >
                          <MenuItem value="int">Integer</MenuItem>
                          <MenuItem value="string">String</MenuItem>
                          <MenuItem value="float">Float</MenuItem>
                          <MenuItem value="timestamp">Timestamp</MenuItem>
                        </TextField>
                      </TableCell>
                      <TableCell>
                        <TextField
                          name="alias"
                          label="Alias"
                          value={row.alias}
                          disabled={disableForm}
                          onChange={(e) =>
                            handleHeaderChange({
                              header: row.header,
                              alias: e.target.value,
                              checked: true,
                              cast_datatype: row.cast_datatype ? row.cast_datatype : 'string',
                              default_value: row.default_value,
                              attribute_type: row.attribute_type,
                            })
                          }
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Box
          component="form"
          sx={{
            '& > :not(style)': { m: 2, width: '32ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <Button disabled={disableForm} variant="contained" endIcon={<AddIcon />} onClick={handleAddColumnModalOpen}>
            Add Column
          </Button>
          <TextField
            id="outlined-basic"
            select
            label="Persist"
            variant="outlined"
            value={formField.persist}
            name="persist"
            onChange={handleInputChange}
            size="small"
            disabled={disableForm}
            required
            InputProps={{
              style: {
                fontFamily: "'EB Garamond', serif ",
                fontWeight: 600,
              },
            }}
            InputLabelProps={{ style: { fontFamily: "'EB Garamond', serif " } }}
          >
            <MenuItem value>true</MenuItem>
            <MenuItem value={false}>false</MenuItem>
          </TextField>

          {formField.persist === true && (
            <TextField
              id="outlined-basic"
              select
              label="Persist Type"
              variant="outlined"
              value={formField.persist_type}
              name="persist_type"
              onChange={handleInputChange}
              sx={{ mt: 2 }}
              size="small"
              disabled={disableForm}
              required
            >
              <MenuItem value="DISK_ONLY">DISK_ONLY</MenuItem>
              <MenuItem value="DISK_ONLY_2">DISK_ONLY_2</MenuItem>
              <MenuItem value="MEMORY_ONLY">MEMORY_ONLY</MenuItem>
              <MenuItem value="MEMORY_ONLY_2">MEMORY_ONLY_2</MenuItem>
              <MenuItem value="MEMORY_AND_DISK">MEMORY_AND_DISK</MenuItem>
              <MenuItem value="MEMORY_AND_DISK_2">MEMORY_AND_DISK_2</MenuItem>
            </TextField>
          )}
        </Box>
        {(formField.format === 'oracle' || formField.format === 'mysql' || formField.format === 'postgres') && (
          <Grid container spacing={2} sx={{ mx: 1 }}>
            <Grid item xs={4}>
              <Checkbox
                disabled={disableForm}
                name="pagination"
                {...checklabel}
                checked={formField.pagination}
                onChange={handleInputChange}
              />
              Pagination
            </Grid>
            {formField.pagination === true && (
              <>
                <Grid item xs={4}>
                  <TextField
                    name="numPartitions"
                    label="Number Partition"
                    value={formField.numPartitions}
                    onChange={handleInputChange}
                    size="small"
                    type="number"
                    disabled={disableForm}
                    required
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    name="partitionColumn"
                    label="Partition Column"
                    value={formField.partitionColumn}
                    onChange={handleInputChange}
                    size="small"
                    type="number"
                    disabled={disableForm}
                    required
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    name="lowerBound"
                    label="LowerBound"
                    value={formField.lowerBound}
                    onChange={handleInputChange}
                    size="small"
                    type="number"
                    disabled={disableForm}
                    required
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    name="upperBound"
                    label="UpperBound"
                    value={formField.upperBound}
                    onChange={handleInputChange}
                    size="small"
                    type="number"
                    disabled={disableForm}
                    required
                  />
                </Grid>
              </>
            )}
          </Grid>
        )}
        <Grid container spacing={2} sx={{ mx: 1 }}>
          <Grid item xs={4}>
            <InputField
              name="action"
              label="Action"
              value={formField.action}
              onChange={handleInputChange}
              size="small"
              disabled={disableForm}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="outlined-select-currency"
              select
              label="Distinct Rows"
              size="small"
              value={formField.distinct_rows}
              onChange={(event) => {
                setFormField({
                  ...formField,
                  distinct_rows: event.target.value,
                });
              }}
              disabled={disableForm}
              style={{ width: '100%', marginTop: '15px' }}
            >
              <MenuItem value="true">true</MenuItem>
              <MenuItem value="false">false</MenuItem>
            </TextField>
          </Grid>
        </Grid>
      </div>
      <Modal
        open={addColumnModalOpen}
        onClose={handleAddColumnModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Radio.Group
            options={attributeOptions}
            size="large"
            name="DataTypeRadio"
            onChange={(e) => setAttributeType(e.target.value)}
            value={attributeType}
            disabled={disableForm}
          />
          <InputField
            name="header"
            label="Attribute"
            onChange={(e) => setAddColumn(e.target.value)}
            size="small"
            required
          />
          <InputField
            name="default_value"
            label="Default Value"
            onChange={(e) => setDefaultValue(e.target.value)}
            size="small"
            required
          />

          <Button
            variant="contained"
            sx={{ mt: 2 }}
            color="secondary"
            type="submit"
            className="button-color"
            onClick={handleAddColumn}
          >
            Add
          </Button>
        </Box>
      </Modal>
    </>
  );

  return dataModel ? (
    content
  ) : (
    <div>
      <Dialog
        fullScreen
        open={open}
        // onClose={handleClose}
        TransitionComponent={Transition}
        style={{ width: '70%', marginLeft: '30%' }}
      >
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: 'relative', backgroundColor: '#fff' }}>
            <Toolbar>
              <IconButton edge="start" onClick={handleClose} aria-label="close" sx={{ color: '#00043C' }}>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: '#00043C' }} variant="h6" component="div">
                {/* {nodeName} */}
                Read Postgres
              </Typography>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  className="outlined-button-color"
                  disabled={!disableForm}
                  onClick={handleEdit}
                >
                  Edit
                </Button>
                <Button type="submit" size="small" variant="contained" disabled={disableForm} className="button-color">
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>
          {content}
        </form>
      </Dialog>
    </div>
  );
};

export default memo(NodeModalReadPostgres2);
